export const palette = () => ({
    black: {
        main: '#000000'
    },
    blue: {
        light: '#42a4ff',
        main: '#3346D1',
        ultralight: '#d9eafa'
    },
    error: {
        main: '#750000'
    },
    font: {
        light: '#8b8b8b'
    },
    green: {
        contrastText: '#fff',
        dark: '#0F5663',
        light: '#2AB4AD',
        main: '#1BCC00',
        stock: '#78CD6B',
        transparency: '#2370657a',
        ultralight: '#CCFDDD'
    },
    grey: {
        border: '#c1c1c1',
        dark: '#808080',
        light: '#DFDFDF',
        main: '#ABABAB',
        semidark: '#7A7A7A',
        semilight: '#e0e0e0',
        ultralight: '#EEE'
    },
    orange: {
        light: '#eb8909',
        main: '#FF7614'
    },
    primary: {
        dark: '#126D7D',
        light: '#3BCAE3',
        main: '#1890A5'
    },
    red: {
        dark: '#B30000',
        light: '#DF4343',
        main: '#E00000'
    },
    secondary: {
        dark: '#750000',
        light: '#FF3D3D',
        main: '#B30000'
    },
    success: {
        main: '#1890A5'
    },
    white: {
        dark: '#F2F2F2',
        main: '#FFFFFF',
        secondary: '#FAFAFA'
    },
    yellow: {
        main: '#CCC200'
    }
});
